import { ProfileBaseItemType, profileBaseItemTypes, ProfileItemType } from '@hb/shared'

export const isProfileBaseItemType = (type: string): type is ProfileBaseItemType =>
  profileBaseItemTypes.includes(type as ProfileBaseItemType)

export const profileItemTypes: Array<ProfileItemType> = ['patient', 'pregnancy', 'claim'] // 'visit'
export const isProfileItemType = (type: string): type is ProfileItemType =>
  profileItemTypes.includes(type as ProfileItemType)

export const toProfileItemType = (type: ProfileBaseItemType): ProfileItemType => {
  switch (type) {
    case 'pregnancies':
      return 'pregnancy'
    case 'claims':
      return 'claim'
    // case 'visits':
    //   return 'visit'
    case 'patients':
      return 'patient'
    default:
      throw new Error(`Invalid base item type: ${type}`)
  }
}
